import { debounce, clone, cloneDeep } from "lodash";
import { mapState, mapActions, mapGetters } from "vuex";

import Tag from "components/form/input/_tag";
import UserSelect from "components/form/input/_user-select";

export default {
  components: {
    UserSelect,
    Tag,
  },
  props: {
    update: {
      type: Function,
      default: function(params) {
        return this.updateUserStory(params)
      }
    }
  },
  data: function () {
    return {
      showUserSwitcher: false,
      dirty: false,
      editTitle: false,
      edit: {
        title: false,
        description: false,
        tech_notes: false,
      },
      saveDebounce: debounce(function () {
        this.handleUpdateUserStory();
      }, 5000),
    };
  },
  computed: {
    ...mapState("users", ["users"]),

    ...mapGetters("yodizproject/tasks", {
      getByStoryIdAndStatus: "getByStoryIdAndStatus",
    }),

    stateTitle: {
      get() {
        return this.story.title;
      },

      set(value) {
        this.setStoryListProperty({
          id: this.story.id,
          property: "title",
          value: value,
        });
      },
    },

    stateDescription: {
      get() {
        return this.story.description;
      },

      set(value) {
        this.setStoryListProperty({
          id: this.story.id,
          property: "description",
          value: value,
        });
      },
    },

    stateTechNotes: {
      get() {
        return this.story.tech_notes;
      },

      set(value) {
        this.setStoryListProperty({
          id: this.story.id,
          property: "tech_notes",
          value: value,
        });
      },
    },

    stateTags: {
      get() {
        return this.story.tags;
      },

      set(value) {
        this.setStoryListProperty({
          id: this.story.id,
          property: "tags",
          value,
        });
      },
    },

    statusClass() {
      switch (this.storyStatus) {
        case "New":
          return "default";
          break;
        case "In Progress":
          return "warning";
          break;
        case "Review":
          return "info";
          break;
        case "Completed":
          return "success";
          break;
      }
    },

    storyStatus() {
      let orderedStatuses = ["New", "In Progress", "Review", "Completed"]
      let status = "New"

      for (var index in orderedStatuses) {
        if (
          this.getByStoryIdAndStatus(this.localStory.id, orderedStatuses[index])
            .length > 0
        ) {
          status = orderedStatuses[index]

          if (status === 'New' && this.getByStoryIdAndStatus(this.localStory.id, orderedStatuses.filter( status => status !== 'New')).length > 0) {
            status = 'In Progress'
          }
          break
        }
      }

      return status
    },
  },
  methods: {
    ...mapActions("yodizproject/stories", {
      setStoryListProperty: "setSingleListProperty",
      updateUserStory: "updateListObject",
      deleteUserStory: "deleteListObject",
    }),

    getFormattedField(field) {
      return this.localStory[field]
        ? this.localStory[field].replace(/(?:\r\n|\r|\n)/g, "<br>")
        : null;
    },

    markDirty() {
      this.dirty = true;
      //this[SET_SAVE_STATUS](AppConstants.save_status.UNSAVED)

      this.saveDebounce();
    },

    userChanged(user) {
      this.localStory.user = user
      this.localStory.creator_id = user ? user.id : null

      this.markDirty();
      this.handleUpdateUserStory();
    },

    handleUpdateUserStory() {
      //This stops old debouced saved calls from trigering the save again.
      //For edit to be true, the input blur event hasn't been triggered yet which also performs a save
      if (this.dirty) {
        return this.update({ id: this.localStory.id, payload: this.localStory })
          .then((response) => {
            this.dirty = false;
            //this[SET_SAVE_STATUS](AppConstants.save_status.SAVED)
          })
          .catch((response) => {
            notify.error(
              response.response.data.errors[
                Object.keys(response.response.data.errors)[0]
              ]
            );
          });
      }
    },

    onFieldClick(field) {
      this.edit[field] = true;

      this.$nextTick(() => {
        this.$refs[field].focus();
      });
    },

    // onTitleClick() {
    //     this.editTitle = true

    //     this.$nextTick(() => {
    //         this.$refs.stateTitle.focus()
    //     })
    // },

    onFieldBlur(field) {
      this.edit[field] = false;

      this.handleUpdateUserStory();
    },

    // onTitleBlur() {
    //     this.editTitle = false

    //     this.handleUpdateUserStory()
    // },

    getAvatar: function (id) {
      return process.env.VUE_APP_API_URL + "/user/" + id + "/avatar";
    },

    onDeleteClick() {
      this.$swal({
        title: "Confirm Delete",
        html: "Are you sure you want to delete this item #" + this.localStory.id,
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Delete",
      }).then(
        () => {
          this.deleteUserStory({ id: this.localStory.id });
        },
        function () {}
      );
    },

    handleSelectTagCallback(tags) {
      if (tags) {
        this.localStory.tags = tags;
      } else {
        this.localStory.tags = [];
      }

      this.markDirty();
      this.handleUpdateUserStory();
    },

    handleAddNewTag(tag) {
      this.localStory.tags.push(tag);
      this.markDirty();
      this.handleUpdateUserStory();
    },
  },
}
